
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForceGustsTrue as ObiForceGustsTrueElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-force-gusts-true.js';
 
 
 

 
 export const ObiForceGustsTrue = createComponent({
   react: React,
   tagName: 'obi-force-gusts-true',
   elementClass: ObiForceGustsTrueElement,
   events: {
     
   }
  });
 
 